<template>

<main class="lg:mb-[600px] relative z-10 bg-backgroundBody dark:bg-dark">
<!--=====================================
   Page Header Section
======================================-->
<section
  class="pt-28 sm:pb-28 max-md:pb-16 md:py-[155px] lg:py-[177px] relative z-50 overflow-hidden"
>
  <div
    id="hero-gradient-wrapper"
    class="absolute w-full h-full top-0 left-0 -z-10 blur-[35px] md:blur-[60px] scale-75"
  >
    <!-- Gradient Background Image: Positioned centrally with responsive sizing -->
    <img
      src="@/assets/images/hero-gradient-background.png"
      alt="hero-gradient-background"
      id="hero-gradient"
      class="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2"
    />
  </div>

  <!-- Content Container -->
  <div class="container">
    <!-- Centered Content with Animation -->
    <div class="text-center reveal-me">
      <!-- Badge Component -->
      <div class="rv-badge">
        <span class="rv-badge-text">Project</span>
      </div>

      <!-- Title and Description -->
      <h1 class="mt-3.5 sm:mt-5 lg:mt-9 mb-3 sm:mb-4 lg:mb-7">Quality stuff.<span class="font-instrument italic"> In every <br class="hidden md:block "> project.</span></h1>
      <p></p>
    </div>
  </div>
</section>


<section class="pb-14 md:pb-16 lg:pb-[88px] xl:pb-[100px]">
  <div class="container">
    <div class="grid grid-cols-1 md:grid-cols-2 gap-6 max-xs:px-5">
      <div class="relative group cursor-pointer reveal-me">
        <router-link to="/pairboard" class="w-full">
          <figure class="overflow-hidden">
            <img
              class="w-full h-full block transition-all duration-500 group-hover:scale-125"
              src="@/assets/images/services/services-1.png"
              alt="Services Image"
            />
          </figure>
          <div
            class="bg-secondary/50 backdrop-blur w-[calc(100%-20px)] py-2.5 pl-5 sm:pl-10 mx-2.5 absolute bottom-4 pr-2.5 flex items-center justify-between group-hover:scale-[1.01] transition-all duration-500"
          >
            <h3 class="text-white text-2xl lg:text-[32px]">Pairboard</h3>
            <figure
              class="bg-primary p-7 lg:p-8 cursor-pointer relative overflow-hidden"
            >
              <img
                src="@/assets/images/icons/arrow-Icon.svg"
                alt="Arrow Icon"
                class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 group-hover:-translate-y-12 group-hover:translate-x-8 transition-all duration-500 opacity-100 group-hover:opacity-0"
              />
              <img
                src="@/assets/images/icons/arrow-Icon.svg"
                alt="Arrow Icon"
                class="absolute translate-y-8 -translate-x-12 transition-all duration-500 opacity-0 group-hover:opacity-100 group-hover:-translate-x-2.5 group-hover:-translate-y-2"
              />
            </figure>
          </div>
        </router-link>
      </div>
      <div class="relative group cursor-pointer reveal-me">
        <router-link to="/off-melrose" class="w-full">
          <figure class="overflow-hidden">
            <img
              class="w-full h-full block transition-all duration-500 hover:scale-125"
              src="@/assets/images/services/services-2.png"
              alt="Services Image"
            />
          </figure>
          <div
            class="bg-secondary/50 backdrop-blur w-[calc(100%-20px)] py-2.5 pl-5 sm:pl-10 mx-2.5 absolute bottom-4 pr-2.5 flex items-center justify-between group-hover:scale-[1.01] transition-all duration-500"
          >
            <h3 class="text-white text-2xl lg:text-[32px]">Off Melrose</h3>
            <figure
              class="bg-primary p-7 lg:p-8 cursor-pointer relative overflow-hidden"
            >
              <img
                src="@/assets/images/icons/arrow-Icon.svg"
                alt="Arrow Icon"
                class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 group-hover:-translate-y-12 group-hover:translate-x-8 transition-all duration-500 opacity-100 group-hover:opacity-0"
              />
              <img
                src="@/assets/images/icons/arrow-Icon.svg"
                alt="Arrow Icon"
                class="absolute translate-y-8 -translate-x-12 transition-all duration-500 opacity-0 group-hover:opacity-100 group-hover:-translate-x-2.5 group-hover:-translate-y-2"
              />
            </figure>
          </div>
        </router-link>
      </div>
      <div class="relative group cursor-pointer reveal-me">
        <router-link to="/finify" class="w-full">
          <figure class="overflow-hidden">
            <img
              class="w-full h-full block transition-all duration-500 hover:scale-125"
              src="@/assets/images/services/services-3.png"
              alt="Services Image"
            />
          </figure>
          <div
            class="bg-secondary/50 backdrop-blur w-[calc(100%-20px)] py-2.5 pl-5 sm:pl-10 mx-2.5 absolute bottom-4 pr-2.5 flex items-center justify-between group-hover:scale-[1.01] transition-all duration-500"
          >
            <h3 class="text-white text-2xl lg:text-[32px]">Finify</h3>
            <figure
              class="bg-primary p-7 lg:p-8 cursor-pointer relative overflow-hidden"
            >
              <img
                src="@/assets/images/icons/arrow-Icon.svg"
                alt="Arrow Icon"
                class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 group-hover:-translate-y-12 group-hover:translate-x-8 transition-all duration-500 opacity-100 group-hover:opacity-0"
              />
              <img
                src="@/assets/images/icons/arrow-Icon.svg"
                alt="Arrow Icon"
                class="absolute translate-y-8 -translate-x-12 transition-all duration-500 opacity-0 group-hover:opacity-100 group-hover:-translate-x-2.5 group-hover:-translate-y-2"
              />
            </figure>
          </div>
        </router-link>
      </div>
      <div class="relative group cursor-pointer reveal-me">
        <router-link to="/blingram" class="w-full">
          <figure class="overflow-hidden">
            <img
              class="w-full h-full block transition-all duration-500 hover:scale-125"
              src="@/assets/images/services/services-4.png"
              alt="Services Image"
            />
          </figure>
          <div
            class="bg-secondary/50 backdrop-blur w-[calc(100%-20px)] py-2.5 pl-5 sm:pl-10 mx-2.5 absolute bottom-4 pr-2.5 flex items-center justify-between group-hover:scale-[1.01] transition-all duration-500"
          >
            <h3 class="text-white text-2xl lg:text-[32px]">Blingram</h3>
            <figure
              class="bg-primary p-7 lg:p-8 cursor-pointer relative overflow-hidden"
            >
              <img
                src="@/assets/images/icons/arrow-Icon.svg"
                alt="Arrow Icon"
                class="absolute left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2 group-hover:-translate-y-12 group-hover:translate-x-8 transition-all duration-500 opacity-100 group-hover:opacity-0"
              />
              <img
                src="@/assets/images/icons/arrow-Icon.svg"
                alt="Arrow Icon"
                class="absolute translate-y-8 -translate-x-12 transition-all duration-500 opacity-0 group-hover:opacity-100 group-hover:-translate-x-2.5 group-hover:-translate-y-2"
              />
            </figure>
          </div>
        </router-link>
      </div>
    </div>
  </div>
</section>


<!--=====================================
   CTA Section
======================================-->
<section
class="pt-14 md:pt-16 lg:pt-[88px] xl:pt-[100px] pb-[70px] lg:pb-[140px] relative"
>
<div class="container">
  <!-- CTA Heading -->
  <h2
    class="text-center xl:text-[96px] font-normal xl:leading-[1.1] xl:tracking-[-2.88px]"
  >
    Got Questions?
    <span class="font-instrument sm:mt-10 italic block max-md:inline-block"
      >We’ve Got Answers</span
    >
  </h2>

  <ul
  class="flex flex-col md:flex-row justify-center items-center gap-4 md:gap-6 list-none"
>
    <!-- Primary CTA Button -->
    <li
      class="block md:inline-block w-[90%] mx-auto md:ml-auto md:mr-0 md:w-auto"
    >
    
    </li>
    <!-- Secondary CTA Button -->
    <li
      class="block md:inline-block w-[90%] mx-auto md:mr-auto md:ml-0 md:w-auto"
    >
      <router-link
        to="/contact"
        class="rv-button rv-button-primary block md:inline-block"
      >
        <div class="rv-button-top contact-btn-lg">
          <span>Let's Connect</span>
        </div>
        <div class="rv-button-bottom contact-btn-lg">
          <span>Let's Connect</span>
        </div>
      </router-link>
    </li>
  </ul>
</div>
</section>

</main>
<!--=====================================
   Footer Section
======================================-->
<FooterComponent/>
</template>

<script>
import FooterComponent from '@/components/FooterComponent.vue'
export default {
  name: 'PortfolioPage',
  components: {
    FooterComponent,
  }
}
</script>